module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"HomePage":"Главная","My Account":"Мой профиль","Tips":"Подсказки","Hide Tips":"Скрыть подсказки","How-Tos":"Справка"}}')
  delete Component.options._Ctor
}
